export default "__VITE_ASSET__9VVwlWXB__"